module.exports = __webpack_public_path__ + "media/images/component/source-4e8de265da71a90832e95a8591232dc7.svg";